<template>
  <router-view />
  <!-- <custom-select /> -->
</template>

<script setup>
import { onMounted} from "vue";

onMounted(() => {
  // 清除缓存
});
</script>

<style lang="scss">
.page-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.btn-space {
  margin-bottom: 16px;
}
</style>
